import api from '@/lib/api';
import type { TodoChecklistItemResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useChecklist } from './useChecklist';

/**
 * The checklist (lightweight text + checkbox breakdown) of a single shared task.
 * Mutations refresh both the checklist and the parent list's items query, so the
 * "N/M" checklist badge on the task row stays current. Thin wrapper over the
 * shared {@link useChecklist} engine.
 */
export function useTodoChecklist(
  holderId: string | null,
  listId: string,
  itemId: string | null,
  enabled = true,
) {
  return useChecklist<TodoChecklistItemResponse>({
    holderId,
    id: itemId,
    enabled,
    key:
      holderId && itemId
        ? queryKeys.todoLists.checklist(holderId, listId, itemId)
        : ['todoLists', 'checklist', 'disabled'],
    secondaryKey: (h) => queryKeys.todoLists.detail(h, listId),
    list: (h, id) => api.listTodoChecklist(h, id),
    create: (h, id, title) => api.createTodoChecklistItem(h, id, title),
    setDone: (h, checklistItemId, isDone) =>
      api.updateTodoChecklistItem(h, checklistItemId, { isDone }),
    remove: (h, checklistItemId) => api.deleteTodoChecklistItem(h, checklistItemId),
    reorder: (h, id, order) => api.reorderTodoChecklist(h, id, order),
  });
}
